"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.durationFromAccelerationDecelerationDistanceAndRunningSpeed = exports.maxSpeedFromAccelerationDecelerationAndDistance = exports.speedFromAccelerationAndDistance = exports.distanceFromAccelerationAndSpeed = exports.sqFeetToSqMeters = exports.milesToKm = exports.kmToMiles = exports.feetToMeters = exports.metersToFeet = exports.milesToMeters = exports.metersToMiles = exports.mphToMps = exports.mpsToMph = exports.mphToKph = exports.kphToMph = exports.ftpsToMps = exports.mpsToFtps = exports.mpsToKph = exports.kphToMps = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const kphToMps = function (kph) {
    return kph / 3.6;
};
exports.kphToMps = kphToMps;
const mpsToKph = function (mps) {
    return mps * 3.6;
};
exports.mpsToKph = mpsToKph;
// M/s to ft/s
const mpsToFtps = function (mps) {
    return mps * 3.281;
};
exports.mpsToFtps = mpsToFtps;
const ftpsToMps = function (ftps) {
    return ftps / 3.281;
};
exports.ftpsToMps = ftpsToMps;
const kphToMph = function (kph) {
    return kph / 1.60934;
};
exports.kphToMph = kphToMph;
const mphToKph = function (mph) {
    return mph * 1.60934;
};
exports.mphToKph = mphToKph;
const mpsToMph = function (mps) {
    return mps * 2.23694;
};
exports.mpsToMph = mpsToMph;
const mphToMps = function (mph) {
    return mph / 2.23694;
};
exports.mphToMps = mphToMps;
const metersToMiles = function (meters) {
    return meters / 1609.34;
};
exports.metersToMiles = metersToMiles;
const milesToMeters = function (miles) {
    return miles * 1609.34;
};
exports.milesToMeters = milesToMeters;
const metersToFeet = function (meters) {
    return meters * 3.281;
};
exports.metersToFeet = metersToFeet;
const feetToMeters = function (feet) {
    return feet / 3.281;
};
exports.feetToMeters = feetToMeters;
const kmToMiles = function (km) {
    return km / 1.60934;
};
exports.kmToMiles = kmToMiles;
const milesToKm = function (miles) {
    return miles * 1.60934;
};
exports.milesToKm = milesToKm;
const sqFeetToSqMeters = function (sqFeet) {
    if (sqFeet < 0) {
        return NaN;
    }
    return sqFeet * 0.092903;
};
exports.sqFeetToSqMeters = sqFeetToSqMeters;
const distanceFromAccelerationAndSpeed = function (accelerationMps2, speedMps) {
    return (speedMps * speedMps) / (2 * accelerationMps2);
};
exports.distanceFromAccelerationAndSpeed = distanceFromAccelerationAndSpeed;
const speedFromAccelerationAndDistance = function (accelerationMps2, distanceM) {
    return Math.sqrt(2 * accelerationMps2 * distanceM);
};
exports.speedFromAccelerationAndDistance = speedFromAccelerationAndDistance;
const maxSpeedFromAccelerationDecelerationAndDistance = function (accelerationMps2, decelerationMps2, distanceM) {
    return Math.sqrt((2 * accelerationMps2 * decelerationMps2 * distanceM) / (accelerationMps2 + decelerationMps2));
};
exports.maxSpeedFromAccelerationDecelerationAndDistance = maxSpeedFromAccelerationDecelerationAndDistance;
// get total duration including acceleration and deceleration, with a running speed, which could be impossible to reach if too great:
// if running speed is too high, the maximum running speed will be used instead:
const durationFromAccelerationDecelerationDistanceAndRunningSpeed = function (accelerationMps2, decelerationMps2, distanceM, runningSpeedMps) {
    const maxSpeedMps = maxSpeedFromAccelerationDecelerationAndDistance(accelerationMps2, decelerationMps2, distanceM);
    runningSpeedMps = Math.min(runningSpeedMps, maxSpeedMps);
    const accelerationDistanceM = distanceFromAccelerationAndSpeed(accelerationMps2, runningSpeedMps);
    const decelerationDistanceM = distanceFromAccelerationAndSpeed(decelerationMps2, runningSpeedMps);
    return (runningSpeedMps / accelerationMps2 +
        runningSpeedMps / decelerationMps2 +
        (distanceM - accelerationDistanceM - decelerationDistanceM) / runningSpeedMps);
};
exports.durationFromAccelerationDecelerationDistanceAndRunningSpeed = durationFromAccelerationDecelerationDistanceAndRunningSpeed;
//# sourceMappingURL=PhysicsUtils.js.map